module.exports = __webpack_public_path__ + "assets/user_plus-d58791.svg";